/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { ModalDelete } from "Blueprints";
import NewDeleteIcon from "assets/general/NewDeleteIcon";
import ButtonsGroup from "components/ui/ButtonsGroup";
import PageHeader from "components/ui/PageHeader";
import Text from "components/ui/Text";
import useDevAttributes from "hooks/useDevAttributes";
import { deleteAdmin } from "lib/v2/adminsApi";
import { useParams } from "react-router-dom";
import { useUI } from "state";

const AdminFormPageHeader = ({
  formType,
  setLoading,
  isLoading,
  onSubmit,
  formPermissions,
  goBack,
  pageHeaderProps,
}) => {
  const { openModal, closeModal } = useUI();
  const { id } = useParams();

  const { deleteModalAttr } = useDevAttributes({
    deleteModalAttr: "delete-admin",
  });

  return (
    <PageHeader title="Admin Details" {...pageHeaderProps} test-id="9ixPg9Y-">
      <div className="flex space-x-1 sm:space-x-2" test-id="8Yei_MNn">
        <ButtonsGroup
          buttons={[
            {
              children: formType === "create" ? "Create" : "Save",
              variant: "pg-header-primary",
              isLoading: isLoading,
              onClick: onSubmit,
              hidden:
                !formPermissions.isEditable && !formPermissions.isCreatable,
            },
            {
              children: "Cancel",
              variant: "pg-header-secondary",
              onClick: goBack,
            },

            {
              variant: "unstyled",
              children: (
                <div
                  className="pl-4 flex items-start space-x-1 !w-28 py-2.5"
                  test-id="BLYAScNg"
                >
                  <div
                    className="flex !px-10!h-[30px] items-center w-full"
                    test-id="bzByE-47"
                  >
                    <NewDeleteIcon size="large" test-id="rgEBF869" />

                    <Text
                      as="strong"
                      className="text-base ml-2  text-[#E46D64]"
                      test-id="wkT7zQDR"
                    >
                      Delete
                    </Text>
                  </div>
                </div>
              ),

              ...deleteModalAttr,
              onClick: () =>
                openModal({
                  content: (
                    <ModalDelete
                      title="Are you sure?"
                      onDelete={async () => {
                        setLoading(true);
                        const { status } = await deleteAdmin(id);
                        setLoading(false);

                        if (status === "SUCCESS") {
                          closeModal();
                          goBack();
                        }
                      }}
                      test-id="56-glQIA"
                    />
                  ),
                }),
              hidden: !formPermissions.canDelete,
            },
          ]}
          test-id="HIH6Mas0"
        />
      </div>
    </PageHeader>
  );
};

export default AdminFormPageHeader;
